import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";

export const Footer = () => {
  const navigate = useNavigate()
  return (
    <Fragment>
      <footer className="bg-white iq-footer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6">
            Copyright © 2024 <a href="https://frameophotography.in/" target="_blank" style={{color: '#bf9456'}}>Frameo</a>
            </div>
            <div className="col-lg-6 text-right">
            Powered by <a href="https://amytechnologies.in/" target="_blank" style={{color: '#8e6cd3'}}> AMY Technologies</a>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
};
